/*
 * Copyright 2019 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */
// AWS Amplify v6 - Core
export { Amplify } from 'aws-amplify';
export { ConsoleLogger, Hub, I18n, ServiceWorker, Cache } from 'aws-amplify/utils';
// Auth - v6 uses functional API
export { signIn, signOut, signUp, confirmSignIn, confirmSignUp, resetPassword, confirmResetPassword, fetchAuthSession, getCurrentUser, updatePassword, updateUserAttribute, updateUserAttributes, fetchUserAttributes, sendUserAttributeVerificationCode, confirmUserAttribute, deleteUser, deleteUserAttributes, setUpTOTP, verifyTOTPSetup, updateMFAPreference, fetchMFAPreference, signInWithRedirect, fetchDevices, rememberDevice, forgetDevice, autoSignIn, resendSignUpCode, decodeJWT, } from 'aws-amplify/auth';
// API - REST
export { get, post, put, del, head, patch, } from 'aws-amplify/api';
// API - GraphQL
export { generateClient, } from 'aws-amplify/api';
// Storage
export { uploadData, downloadData, remove, list, getUrl, getProperties, copy, isCancelError as isStorageCancelError, } from 'aws-amplify/storage';
// Analytics
export { record, identifyUser, enable as enableAnalytics, disable as disableAnalytics, flushEvents, configureAutoTrack, } from 'aws-amplify/analytics';
// SSR Context (deprecated in v6, kept for compatibility)
export { withSSRContext } from './withSSRContext';
/**
 * @deprecated use named import
 */
export { Amplify as default } from 'aws-amplify';
//# sourceMappingURL=index.js.map